import { render, staticRenderFns } from "./WF7_Agreement.vue?vue&type=template&id=11a0c8f8"
import script from "./WF7_Agreement.vue?vue&type=script&lang=js"
export * from "./WF7_Agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports